// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

export type AssetTableColumn =
  | 'serial'
  | 'project'
  | 'product'
  | 'location'
  | 'zone'
  | 'owner'
  | 'activity';

/**
 * The default set of columns displayed in the asset table. Zone is excluded
 * because zone information is already embedded in the location name via
 * getEffectiveLocationName (e.g., "Chicago Warehouse — Zone A"). Zone should
 * only be added explicitly in contexts where the location column is hidden.
 */
export const ASSET_TABLE_COLUMNS: AssetTableColumn[] = [
  'serial',
  'project',
  'product',
  'location',
  'owner',
  'activity',
];
